function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
}

module.exports = _includesWith;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_includesWith.js
// module id = 325
// module chunks = 0